interface Props {
  setOpenEnroll: () => void
}

export const StartProgramButton = ({ setOpenEnroll }: Props) => {

  return (
    <div>
      <div
        onClick={setOpenEnroll}
        className="px-5 py-4 border-2 border-black rounded-md text-lg font-semibold mx-auto mt-4 inline-block cursor-pointer hover:shadow-md">
        Empezar programa
      </div>
    </div>
  )
}